// extracted by mini-css-extract-plugin
module.exports = {"container":"aghanims_container_2CYPW"};